module.exports = __webpack_public_path__ + "static/media/gb-sct.34834d98.svg";